module.exports = new __parcel__URL__("placeholder-horizontal.a3bab587.svg").toString();